import React from "react";
import "./PageLoader.css";

const PageLoader = ({
  title = "Carregando",
  subtitle = "Reunindo os registros da sua mesa...",
  fullScreen = false,
  compact = false,
}) => {
  return (
    <div className={`page-loader ${fullScreen ? "full-screen" : ""} ${compact ? "compact" : ""}`}>
      <div className="page-loader-card" role="status" aria-live="polite">
        <div className="page-loader-mark" aria-hidden="true" />
        <div className="page-loader-copy">
          <p className="page-loader-kicker">Caderno de campo</p>
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        <div className="page-loader-trace" aria-hidden="true"><span /><span /><span /></div>
      </div>
    </div>
  );
};

export default PageLoader;
